// extracted by mini-css-extract-plugin
module.exports = {"modelList":"PartnershipModels_modelList__Mw2tG","list":"PartnershipModels_list__xOfRo","button":"PartnershipModels_button__rM1Zj"};